window.EDM || (window.EDM = {});
var EDM = window.EDM;
EDM.SentimentWidget || (EDM.SentimentWidget =
{
    smileyData: [
        { name: 'good', value: 1 },
        { name: 'neutral', value: 5 },
        { name: 'bad', value: 9 }
    ]
});

function _makeSmileyPixel(name, ratingIdx) {
    return {
        name: name,
        questionid: 'universal_sentiment_widget',
        score: EDM.SentimentWidget.smileyData[ratingIdx].value,
        rating: EDM.SentimentWidget.smileyData[ratingIdx].name,
        action: 'click',
        action_widget_id: 'sentiment'
    };
}

// function _fireSmileyPixel(/*name, ratingIdx*/) {
//     var vals = _makeSmileyPixel.apply(this, arguments);
//     $(window.document).trigger('action', {
//         event_type: 'sentiment',
//         data: vals
//     });
// }

function _makeFeedbackPixel(name, ratingIdx, comment) {
    return {
        name: name,
        questionid: 'universal_sentiment_widget',
        score: EDM.SentimentWidget.smileyData[ratingIdx].value,
        rating: EDM.SentimentWidget.smileyData[ratingIdx].name,
        comment: comment,
        action: 'click',
        action_widget_id: 'sentiment'
    };
}

// function _fireFeedbackPixel(/*name, ratingIdx, comment*/) {
//     var vals = _makeFeedbackPixel.apply(this, arguments);
//     $(window.document).trigger('action', {
//         event_type: 'sentiment',
//         data: vals
//     });
// }

module.exports = {
    makeSmileyPixel: _makeSmileyPixel,
    makeFeedbackPixel: _makeFeedbackPixel
    //fireSmileyClickPixel: _fireSmileyPixel,
    //fireFeedbackPixel: _fireFeedbackPixel
};



//////////////////
// WEBPACK FOOTER
// ./src/interlock/product/sentiment-widget/sentiment-tracking.js
// module id = 191
// module chunks = 0 1